// Central site / business config — pulled from existing nicamotorentals.com
export const SITE = {
  name: "Nica Moto Rentals",
  tagline: "¡VE LA AVENTURA!",
  taglineEn: "Experience the Adventure",
  slogan: "¡Diversión sin límite!",
  yearsInBusiness: 18,
  city: "San Juan del Sur, Nicaragua",
  address: "Av. Vanderbilt, San Juan del Sur",
  phone: "+505 8788 5920",
  whatsapp: "50587885920", // wa.me format
  email: "NicaMotoRentals@gmail.com",
  facebook: "https://www.facebook.com/NicaMotoRentals",
  instagram: "https://www.instagram.com/nicamotorentals/",
  googleBusiness: "https://share.google/G6sItIitz7GJZWiVb",
  directions: "https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqEAgAEEUYExgnGDsYgAQYigUyEAgAEEUYExgnGDsYgAQYigUyDQgBEC4YrwEYxwEYgAQyCAgCEAAYFhgeMggIAxAAGBYYHjIICAQQABgWGB4yBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQgxOTc2ajBqNKgCALACAQ&um=1&ie=UTF-8&fb=1&gl=ni&sa=X&geocode=KbG-aoe-tXWPMcG2mKKr6OcO&daddr=Av.+Vanderbuilt,+San+Juan+del+Sur",
  logo: "/images/logo.png",
};

export const whatsappLink = (text) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

// Both Nica Moto Rentals storefronts in San Juan del Sur
export const LOCATIONS = [
  {
    id: "main",
    name: "Nica Moto Rentals",
    label: "Main Location",
    address: "Av. Vanderbilt, San Juan del Sur, Nicaragua",
    query: "Nica Moto Rentals, Av. Vanderbilt, San Juan del Sur",
    directions: SITE.directions,
    mapLink: "https://share.google/G6sItIitz7GJZWiVb",
    phone: SITE.phone,
    whatsapp: SITE.whatsapp,
  },
  {
    id: "second",
    name: "Nica Moto Rentals 2",
    label: "Second Location",
    address: "Av. Gaspar García Laviana, San Juan del Sur, Nicaragua",
    query: "Nica Moto Rentals 2, Av. Gaspar Garcia Laviana, San Juan del Sur",
    directions:
      "https://www.google.com/maps/dir/?api=1&destination=" +
      encodeURIComponent("Nica Moto Rentals 2, Av. Gaspar Garcia Laviana, San Juan del Sur"),
    mapLink: "https://maps.app.goo.gl/3ycjTZtYVuTs5Lct8",
    phone: SITE.phone,
    whatsapp: SITE.whatsapp,
  },
];

// Keyless Google Maps embed (drops a pin for the given place query)
export const embedSrc = (query) =>
  `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=16&output=embed`;

export const CAR_WASH_SERVICES = [
  { name: "Motorcycle Wash", price: 100, desc: "Full exterior wash for any scooter or motorcycle." },
  { name: "Basic Car Wash", price: 300, desc: "Exterior wash, wheels and windows." },
  { name: "Car Wash with Details", price: 500, desc: "Deep interior + exterior detailing." },
  { name: "Chassis Wash", price: 250, desc: "Undercarriage and chassis pressure wash." },
  { name: "Engine Wash (Diesel)", price: 150, desc: "Degrease and clean diesel engine bays." },
];

export const MAINTENANCE_SERVICES = [
  { name: "Preventive Maintenance", price: 800, desc: "Oil, filters, chain, brakes & safety check to keep you rolling." },
  { name: "General Maintenance", price: 1600, desc: "Complete service: full inspection, tune-up and replacements." },
];

export const HOW_IT_WORKS = [
  { step: "01", title: "Choose Your Motorcycle", desc: "Browse our fleet of scooters, motorcycles & ATVs and pick your perfect ride." },
  { step: "02", title: "Book Online", desc: "Reserve in seconds with a quick deposit — pay the rest on pick-up." },
  { step: "03", title: "Pick Up Your Bike", desc: "Grab your keys & helmet at Av. Vanderbilt, San Juan del Sur." },
  { step: "04", title: "Enjoy the Ride", desc: "Hit the coast, chase the sunset. ¡Diversión sin límite!" },
];

export const WHY_CHOOSE_US = [
  { title: "Diverse Fleet", desc: "Scooters, cruisers, dirt bikes and ATVs for every kind of rider." },
  { title: "Fair Prices", desc: "Transparent pricing with no hidden fees, ever." },
  { title: "Local Expert Support", desc: "We help you plan routes, beaches and the best local activities." },
  { title: "Easy Online Booking", desc: "Reserve your bike in minutes, right from your phone." },
];

export const REVIEWS = [
  { name: "Bozyelbig", text: "Very nice experience! A reliable couple manages the shop with beautiful motorcycle models at fair prices. Highly recommended!" },
  { name: "Brent Firkser", text: "Best moto rental in San Juan del Sur! The family is super nice and the rental process goes very smooth." },
  { name: "Nadia Stauffacher", text: "Best place to rent a Honda Navi. So easy to contact the owner and set the maintenance checks." },
  { name: "Arielle Ferland", text: "Amazing approach from the owners, very professional but also nice, friendly and understanding. 100% recommend." },
];

// Real Google reviews + avatars extracted from nicamotorentals.com "Our Customer Reviews"
export const REVIEWS_FEEDBACK = [
  { name: "Brent Firkser", avatar: "/images/reviews/brent.png", text: "This local, family-run business is the only place in SJDS I would rent a bike from. Vlad takes really good care of his moto's and is a super chill, honest and reliable person." },
  { name: "Nadia Stauffacher", avatar: "/images/reviews/nadia.png", text: "Best moto rental in San Juan del Sur! The family is super nice and the rental process goes very smooth. The bikes are great and we could even leave one of our bags there." },
  { name: "Arielle Ferland", avatar: "/images/reviews/arielle.png", text: "Best place to rent a Honda Navi. I rented it for 1 month. So easy to contact the owner and set the maintenance checks. Ricardo is very lovely and easy going." },
  { name: "Aneta Turečková", avatar: "/images/reviews/aneta.png", text: "Amazing approach from the owners, very professional but also nice, friendly and understanding. 100% recommend. No problems occurred. Very nice people and good service." },
  { name: "Bozyelbig", avatar: "", text: "Very nice experience! A reliable couple manages the shop with beautiful motorcycle models at fair prices. I recommend getting a dirt bike, as the beaches are accessible only by dirt roads. Highly recommended!" },
];

export const BLOG_POSTS = [
  { title: "Eco-Friendly Travel in Nicaragua: Why Motorbike Rentals Are the Smart Choice", date: "Oct 14, 2025", image: "/images/eco-friendly.png", excerpt: "Traveling through Nicaragua isn't just about stunning beaches and epic adventures — it can also be an opportunity to travel more sustainably.", url: "https://nicamotorentals.com/eco-friendly-travel-in-nicaragua-why-motorbike-rentals-are-the-smart-choice/" },
  { title: "Why Choose Nica Moto Rentals? Real Traveler Reviews and What Sets Us Apart", date: "Oct 4, 2025", image: "/images/surf-racks.jpeg", excerpt: "When you're planning your motorcycle adventure in Nicaragua, it's not just about the right bike—it's about choosing the right people.", url: "https://nicamotorentals.com/why-choose-nica-moto-rentals-real-traveler-reviews-and-what-sets-us-apart/" },
  { title: "Ride & Relax: Combining Surf Trips with Motorcycle Rentals in San Juan del Sur", date: "Sep 15, 2025", image: "/images/blog/surf-blog.png", excerpt: "If you're heading to Nicaragua for waves, there's no better base than San Juan del Sur—and no better way to chase surf than on two wheels.", url: "https://nicamotorentals.com/ride-relax-combining-surf-trips-with-motorcycle-rentals-in-san-juan-del-sur/" },
  { title: "Adventure Ready: Best Dual-Sport Motorcycles for Exploring San Juan del Sur", date: "Aug 29, 2025", image: "/images/blog/coastal-road.png", excerpt: "September is Nicaragua's green season—lush, vibrant, and full of adventure. Here are the best dual-sport bikes to explore it.", url: "https://nicamotorentals.com/adventure-ready-best-dual-sport-motorcycles-for-exploring-san-juan-del-sur-in-september/" },
  { title: "Booking a Motorcycle in Nicaragua: Step-by-Step Guide for First-Timers", date: "Aug 27, 2025", image: "/images/blog/how-to-rent.jpg", excerpt: "Exploring Nicaragua by motorcycle is one of the most exciting ways to see the country. Here's your step-by-step booking guide.", url: "https://nicamotorentals.com/booking-a-motorcycle-in-nicaragua-step-by-step-guide-for-first-timers/" },
  { title: "Rain or Shine: Why August Is Perfect for a San Juan del Sur Motorcycle Adventure", date: "Aug 14, 2025", image: "/images/blog/august.png", excerpt: "Traveling in August means discovering Nicaragua at its most authentic—lush landscapes, fewer crowds, and green-season magic.", url: "https://nicamotorentals.com/rain-or-shine-why-august-is-perfect-for-a-san-juan-del-sur-motorcycle-rental-adventure/" },
];

export const GALLERY = [
  { src: "/images/gallery/fb-jungle-shed.jpg", alt: "Honda dirt bikes parked in the Nicaraguan jungle" },
  { src: "/images/gallery/fb-storefront-poster.jpg", alt: "Nica Moto Rentals shop entrance — Choose the path, enjoy the ride" },
  { src: "/images/gallery/staff-friends.jpg", alt: "The Nica Moto Rentals family and friends in San Juan del Sur" },
  { src: "/images/gallery/fb-town-street.jpg", alt: "Motorcycles lined up on a San Juan del Sur street" },
  { src: "/images/gallery/fb-beach-bikes.jpg", alt: "Riders with dirt bikes on a San Juan del Sur beach" },
  { src: "/images/gallery/fb-shop-navi.jpg", alt: "Honda Navi scooters at the Nica Moto Rentals shop" },
  { src: "/images/about-store.jpg", alt: "Nica Moto Rentals storefront in San Juan del Sur" },
  { src: "/images/gallery/about-hero.jpg", alt: "Riding with Nica Moto Rentals in San Juan del Sur" },
  { src: "/images/blog/coastal-road.png", alt: "New coastal road in San Juan del Sur" },
  { src: "/images/gallery/eco-travel.png", alt: "Eco-friendly travel in Nicaragua" },
  { src: "/images/eco-friendly.png", alt: "Eco-friendly travel in Nicaragua" },
  { src: "/images/blog/august.png", alt: "San Juan del Sur in August" },
  { src: "/images/blog/how-to-rent.jpg", alt: "How to rent a motorcycle" },
];
